import React from 'react';
import InputMask from 'react-input-mask';
import { Label } from 'reactstrap';
import { ToolTipFeedBack } from '../Utils/ToolTipFeedBack';
import { translate } from '../../_helpers/messages.helper';
import { connect } from 'react-redux';

// Opcional: se usa Flow, mantenha o type Props. Se não, pode remover.
type Props = {
  label: string,
  name: string,
  id: string,
  value?: string | string[] | number,
  size?: number,
  onChange: any,
  onBlur: any,
  children?: any,
  required: boolean,
  messageValidate?: string,
  placeholder: string,
  disabled: boolean,
  maxLength: number,
  style: any,
  countryCode?: string,
  erroMensagem?: string,
  className?: string,
};

class PhoneInput extends React.Component<Props> {
  static defaultProps = {
    size: 12,
    countryCode: '+55',
  };

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    const name = this.props.name;
    const raw =
      e && e.target && typeof e.target.value !== 'undefined'
        ? e.target.value
        : '';
    const digits = String(raw).replace(/\D/g, '');

    const target = Object.assign({}, e && e.target ? e.target : {}, {
      name: name,
      value: digits,
    });
    const currentTarget = Object.assign(
      {},
      e && e.currentTarget ? e.currentTarget : {},
      { name: name, value: digits }
    );
    const synthetic = Object.assign({}, e, {
      target: target,
      currentTarget: currentTarget,
    });

    this.props.onChange(synthetic);
  }

  render() {
    const { messages, name, countryCode } = this.props;

    const value = this.props.value != null ? String(this.props.value) : '';
    const isBR = (countryCode || '+55') === '+55';

    const match = value.match(/\d+/g);
    const digits = match ? match.join('') : '';

    let mask;
    if (isBR) {
      mask = digits.length < 11 ? '(99) 9999-99999' : '(99) 99999-9999';
    } else {
      mask = '999999999999999';
    }

    let messageValidate;
    if (messages && messages.length > 0) {
      messages.forEach(function (message) {
        if (message.fieldName == name) {
          messageValidate = translate(message.message.code);
        }
      });
    }
    if (this.props.erroMensagem) {
      messageValidate = this.props.erroMensagem;
    }

    const placeholder =
      this.props.placeholder === '' ||
      typeof this.props.placeholder === 'undefined'
        ? isBR
          ? this.props.label
          : 'Somente números (sem DDI)'
        : this.props.placeholder;

    return (
      <div className={this.props.required ? 'input-required' : ''}>
        {this.props.label && (
          <Label
            htmlFor={this.props.name}
            className="label-nowrap"
            title={this.props.label}
          >
            {this.props.label}
            {this.props.required && '*'}
          </Label>
        )}

        <InputMask
          mask={mask}
          maskChar=" "
          id={this.props.id}
          name={this.props.name}
          value={value}
          onChange={this.handleChange}
          autoComplete="new-password"
          required={this.props.required}
          placeholder={placeholder}
          onBlur={this.props.onBlur}
          disabled={!!this.props.disabled}
          inputMode="numeric"
          className={`form-control ${this.props.className || ''} ${
            messageValidate ? 'is-invalid' : ''
          }`}
        >
          {this.props.children}
        </InputMask>

        {messageValidate && (
          <ToolTipFeedBack
            target={this.props.id}
            messageValidate={messageValidate}
          />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { messages } = state.fieldMessage;
  const { alert } = state;
  return { messages, alert };
}

export default connect(mapStateToProps)(PhoneInput);
